module.exports = __webpack_public_path__ + "img/9788958076285.6dc85651.jpg";